<template>
    <div ref="legend" class="legend">
        <!-- <div class="indicator-container">
            <div
                class="arrow"
                v-show="currentColour !== null"
                :key="palette.index"
            ></div>
        </div> -->
        <div class="scale">
            <ul class="labels">
                <template v-for="palette in paletteArray">
                    <li :key="palette.index">
                        <span :style="{ background: palette.colour }" />
                        <span> {{palette.text}} </span>
                    </li>
                </template>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    name: "ChoroplethLegend",
    data: () => ({}),
    props: {
        palette: {
            type: Array,
            required: true,
        },
        map: {
            type: Object,
            required: true,
        },
        google: {
            type: Object,
            required: true,
        },
        minValue: {
            type: Number,
            required: true
        },
        maxValue: {
            type: Number,
            required: true
        }
    },
    mounted() {
        const legend = this.$refs.legend;
        this.map.controls[this.google.maps.ControlPosition.RIGHT_BOTTOM].push(
            legend
        );
    },
    computed: {
        paletteArray() {
            // takes minimum and maximum values and generates legend labels based on this and the number of colours
            let paletteArray = [];
            let paletteLength = this.palette.length;
            if(this.maxValue === this.minValue) {
                paletteArray.push({
                    colour: this.palette[0],
                    index: 0,
                    text: `${this.maxValue.toFixed(2)}`
                })
                return paletteArray
            }
            let labelMultiplier = (this.maxValue - this.minValue) / paletteLength;
            this.palette.forEach((colour, index) => {
                let lowerValue = (index * labelMultiplier) + this.minValue
                let upperValue = ((index + 1) * labelMultiplier) + this.minValue

                paletteArray.push({
                    colour: colour,
                    index: index,
                    text: `${lowerValue.toFixed(2)} - ${upperValue.toFixed(2)}`,
                });
            });

            return paletteArray;
        },
    },
};
</script>
<style scoped>
.legend {
    text-align: left;
    margin-bottom: 8px;
    font-weight: bold;
    font-size: 90%;
    max-height: 10%;
    /* max-width: 200px; */
    margin-bottom: 10px;
    margin-right: 10px;
    background-color: white;
    overflow: hidden;
}
.legend .scale ul {
    margin: 0;
    padding: 0;
    float: left;
    list-style: none;
}
.legend .scale ul li {
    display: block;
    float: left;
    width: 50px;
    text-align: center;
    font-size: 80%;
    list-style: none;
}
.legend ul.labels li span {
    display: block;
    float: left;
    height: 15px;
    width: 50px;
}

/* .legend-step {
    width: 15px;
    height: 10px;
    float: left;
}
.arrow {
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid black;
} */
</style>